import { useEffect } from 'react';

/**
 * Names the browser tab after what the page shows ("Crew Sweatshirt · Marenne"),
 * and puts the previous title back on the way out. Shopper pages used to keep
 * the app's "BasiQR App - the best way to manage your products" (#467).
 * A null or empty title leaves the tab as it is.
 */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
